import { render, staticRenderFns } from "./StTeaserOverviewPress.vue?vue&type=template&id=1eaa940c"
import script from "./StTeaserOverviewPress.vue?vue&type=script&lang=ts"
export * from "./StTeaserOverviewPress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports